import { PropertyFilterFormModel } from '../../components/property-filter-form/PropertyFilterForm';
import { PlaceType } from '../../../services/place/place';
import { ResponseWithInfo } from '../../../services/properties/properties';

export function mapPropertyFilterFormModel<T>(response: ResponseWithInfo<T>): PropertyFilterFormModel {
  const result: Partial<PropertyFilterFormModel> = { price: {}, size: {} };

  const { info: { filters } } = response;

  if (filters.province) {
    result.place = {
      ...filters.province[0].value,
      type: PlaceType.PROVINCE,
    };
  }

  if (filters.locality) {
    result.place = {
      ...filters.locality[0].value,
      type: PlaceType.LOCALITY,
    };
  }

  if (filters.area) {
    result.place = {
      ...filters.area[0].value,
      type: PlaceType.AREA,
    };

    if (filters.locality) {
      result.place.parent = {
        ...filters.locality[0].value,
        type: PlaceType.LOCALITY,
      };
    }
  }

  if (filters.sizeMin) {
    result.size.min = filters.sizeMin[0].value.sizeMin.toString();
  }

  if (filters.sizeMax) {
    result.size.max = filters.sizeMax[0].value.sizeMax.toString();
  }

  if (filters.priceMin) {
    result.price.min = filters.priceMin[0].value.priceMin.toString();
  }

  if (filters.priceMax) {
    result.price.max = filters.priceMax[0].value.priceMax.toString();
  }

  return result;
}
